import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import { useAuth } from "react-oidc-context";
import { useBoolean } from "@fluentui/react-hooks";
import styles from "../POIList/POIList.module.css";
import {
    ActionButton,
    DetailsList,
    IColumn, IconButton,
    IDropdownOption, IDropdownStyles,
    IIconProps,
    IStackStyles,
    MessageBarType,
    SelectionMode,
    Stack,
    StackItem, TooltipOverflowMode
} from "@fluentui/react";
import { initializeIcons } from "@fluentui/font-icons-mdl2";
import { AssessmentItem, POIItem } from "../../../model/ManagePOIListItem";
import {
    fetchAssessmentByPoiId,
    fetchPOIById
} from "../../../services/ManageSystemServices/POIService";
import AddEditDialog from "../Dialogs/AddEditAssessmentDialog";
import DeleteDialog from "../Dialogs/DeleteAssessmentDialog";
import QuickSearch from '../../Admin/QuickSearch/QuickSearch';
import Pagination from "../../Pagination/Pagination";
import EiopaFnPIcons from "../../EiopaFnPIcons/EiopaFnPIcons";
import strings from "../../../loc/strings";
import { displayMessageBar } from "../../LayoutWithAuth/LayoutWithAuth";
import { getUserInfo } from "../../../services/UserInfoService";
import { Delete20Filled, FluentIconsProps } from "@fluentui/react-icons";
import { TooltipHost } from "@fluentui/react/lib/Tooltip";

function PageTitle(props: any) {
    return <StackItem className={styles.PoiListHeader}>{props.title} (for: {props.name})</StackItem>;
}

initializeIcons();

const stackStylesSection: Partial<IStackStyles> = {
    root: {
        marginTop: "10px",
    },
};

const betweenStackStyles: IStackStyles = {
    root: {
        justifyContent: "space-between",
    }
}

const customDropdownStyles: Partial<IDropdownStyles> = {
    dropdown: { width: 400 }

};

const customTextFieldStyles = {
    fieldGroup: {
        width: 400
    },
};
interface Ipagination {
    // isMetricsCalloutVisible: boolean;
    columnsState: IColumn[];
    currentPage: number;
    itemsPerPage: number;
    totalItems: number;
}

function AssessmentList(props: any) {

    let { reqNo } = useParams();
    const auth = useAuth();

    const [DOAssessment, setDOAssessment] = useState<Date | undefined>();
    const [dialogIsHidden, setDialogIsHidden] = React.useState(true);
    const [dialogIsHiddenDelete, setDialogIsHiddenDelete] = React.useState(true);
    const [valueDropdown, setValueDropdown] = React.useState("Edit");

    const [items, setItems] = React.useState<AssessmentItem[]>([]);
    const [itemsAssessment, setItemsAssessment] = React.useState<AssessmentItem[]>([]);
    const [itemsOrg, setItemsOrg] = React.useState<AssessmentItem[]>([]);
    const [itemPOI, setItemPOI] = React.useState<POIItem>();
    const [editItem, setEditItem] = React.useState<AssessmentItem>(Object);
    const [orig] = React.useState<AssessmentItem>(Object);

    //totalitems for pagination
    const [totalItems, settotalItems] = React.useState<number>();

    const initialAssessment = {
        "id": undefined,
        "encryptedId": undefined,
        "personId": props.POIId,
        "assessingCAId": null,
        "internalCARefNo": null,
        "euSectoralLegislatureBasisId": null,
        "euSectoralLegislatureBasis": null,
        "dateOfAssessment": null,
        "createdDate": new Date().toISOString(),
        "createdBy": auth.user?.profile.email,
        "markedForDeletionDate": null,
    };

    // Icons
    const add: IIconProps = { iconName: 'Add' };

    // Function to handle processed data from QuickSearch component
    const handleItemsProcessed = (processedData: any) => {
        settotalItems(processedData.length);

        if (processedData.length > 0) {
            setItems(processedData);
            const startIndex = (state.currentPage - 1) * state.itemsPerPage;
            const endIndex = Math.min(startIndex + state.itemsPerPage, processedData.length);
            const itemsOnCurrentPage = processedData.slice(startIndex, endIndex);

            setItems(itemsOnCurrentPage);
            setState({
                ...state,
                currentPage: 1
            });
        } else {
            setItems([]);
        }
    };

    const handleOpenDialog = () => {
        if (itemPOI?.markedForDeletionDate === null)
            setDialogIsHidden(false);
    };

    const handleOpenDialogDelete = () => {
        setDialogIsHiddenDelete(false);
    };
    const handleActionResponse = (response: string, eiopaErrorMessage?: string) => {
        fetchPOI()
        fetchAssessments();

        switch (response) {
            case "assesscreatetrue":
                displayMessageBar(MessageBarType.success, strings.addNewAssessmentSuccessMessage, false);
                break;
            case "assesscreatefalse":
                displayMessageBar(MessageBarType.error, strings.addNewAssessmentErrorMessage, false);
                break;
            case "assesscreateexist":
                displayMessageBar(MessageBarType.error, strings.addNewAssessmentExistsMessage, false);
                break;
            case "assessedittrue":
                displayMessageBar(MessageBarType.success, strings.updateNewAssessmentSuccessMessage, false);
                break;
            case "assesseditfalse":
                displayMessageBar(MessageBarType.error, strings.updateNewAssessmentErrorMessage, false);
                break;
            case "assesseditexist":
                displayMessageBar(MessageBarType.error, strings.updateNewAssessmentExistMessage, false);
                break;
            case "assessdeletefalse":
                displayMessageBar(MessageBarType.error, strings.deleteNewAssessmentErrorMessage, false);
                break;
            case "assessdeletetrue":
                displayMessageBar(MessageBarType.success, strings.deleteNewAssessmentSuccessMessage, false);
                break;
            case "error":
                // Display the specific error message from the API
                displayMessageBar(MessageBarType.error, eiopaErrorMessage ?? strings.assessmentDefaultErrorMessage, false);
                break;
            default:
                displayMessageBar(MessageBarType.error, eiopaErrorMessage ?? response, false);
                break;
        }
    }

    function fetchPOI() {
        (async function () {
            const _itemsPOI = await fetchPOIById(reqNo ?? "0", auth.user?.id_token);
            setItemPOI(_itemsPOI[0]);
        })();
    }

    useEffect(() => {
        fetchAssessments();
        fetchPOI()
    }, []);

    let userInfo = getUserInfo(auth.user?.id_token);

    function fetchAssessments() {
        // Fetch Assessment data from the API
        (async function () {
            const _items = await fetchAssessmentByPoiId(reqNo, auth.user?.id_token);
            const filteredResult = _items.filter(item => item.assessingCAId === userInfo.ncaCode);

            const combined = filteredResult.map(item => {
                return {
                    ...item,
                    name: item.euSectoralLegislatureBasis?.name
                }
            });

            setItemsAssessment(combined);
            const itemsLength = combined.length;
            settotalItems(itemsLength);
            setItemsOrg(combined);
        })();
    }

    useEffect(() => {
        const startIndex = (state.currentPage - 1) * state.itemsPerPage;
        const endIndex = Math.min(startIndex + state.itemsPerPage, itemsAssessment.length);
        const itemsOnCurrentPage = itemsOrg.slice(startIndex, endIndex);

        setItems(itemsOnCurrentPage);
    }, [itemsOrg]);

    function _onRenderActionsIcon() {
        return <EiopaFnPIcons iconName={"actions"} iconColor={"#0078D4"} />;
    }

    const [isSortedDescendings, { toggle: toggleIsSortedDescendings }] = useBoolean(true);

    const parseDate = (dateStr: string | undefined): Date | undefined => {
        if (!dateStr) return undefined;
        const [day, month, year] = dateStr.split('/').map(Number);
        return new Date(year, month - 1, day);
    };

    const iconStyleProps: FluentIconsProps = {
        primaryFill: "#0078D4",
        className: styles.filterIcon,
    };

    function onRenderPrefix() {
        return <Delete20Filled aria-label={"Filter"} {...iconStyleProps} />;
    }

    function _onRenderActionsMenuIcon() {
        return <></>;
    }

    // Render Column Action
    const _AssessmentColumns: IColumn[] = [
        {
            key: "internalCARefNo",
            name: "CA internal assessment number",
            fieldName: "internalCARefNo",
            minWidth: 200,
            maxWidth: 300,
            isResizable: true,
        },
        {
            key: "name",
            name: "EU sectoral legislative basis",
            fieldName: "name",
            minWidth: 200,
            maxWidth: 300,
            isResizable: true,
        },
        {
            key: "dateOfAssessment",
            name: "Date of assessment",
            fieldName: "dateOfAssessment",
            minWidth: 100,
            isResizable: true,
            isSorted: true,
            isSortedDescending: isSortedDescendings,
            sortAscendingAriaLabel: 'Sorted A to Z',
            sortDescendingAriaLabel: 'Sorted Z to A',
            onColumnClick: _onColumnClick,
        },
        {
            key: "action",
            name: "Actions",
            fieldName: "action",
            minWidth: 100,
            maxWidth: 200,
            isResizable: true,
            onRender: (item: any) => {
                return (
                    <>
                        <IconButton
                            onRenderIcon={_onRenderActionsIcon}
                            title="Settings"
                            onRenderMenuIcon={_onRenderActionsMenuIcon}
                            menuProps={{
                                items: [
                                    {
                                        key: 'edit',
                                        text: 'Edit',
                                        iconProps: { iconName: 'EditSolid12' },
                                        onClick: () => { setEditItem({ ...item }); setDOAssessment(parseDate(item.dateOfAssessment)); setValueDropdown("Edit"); handleOpenDialog(); },
                                    },
                                    {
                                        key: 'delete',
                                        text: 'Delete',
                                        onRenderIcon: onRenderPrefix,
                                        onClick: () => { setEditItem({ ...item }); handleOpenDialogDelete(); },
                                    },
                                ],
                            }}
                        />
                    </>
                );
            },
        },
    ];

    function _onColumnClick(event: React.MouseEvent<HTMLElement>, column: IColumn) {
        toggleIsSortedDescendings();
        let isSortedDescending = column.isSortedDescending;

        if (column.isSorted) {
            isSortedDescending = !isSortedDescending;
        }

        const newItems = column.fieldName === 'dateOfAssessment' ?
            _copyAndSortDate(items, column.fieldName!, !isSortedDescendings) :
            _copyAndSort(items, column.fieldName!, !isSortedDescendings);

        // // setCurrColumn(column);
        // setState({
        //     ...state,
        //     currentPage: 1,
        //     columnsState: columns
        // });
        setItems(newItems);
    }




    function _copyAndSort<T>(items: T[], columnKey: string, isSortedDescending?: boolean): T[] {
        const key = columnKey as keyof T;
        return items.slice(0).sort((a: T, b: T) => ((isSortedDescending ? a[key] < b[key] : a[key] > b[key]) ? 1 : -1));
    }
    function _copyAndSortDate<T>(items: T[], columnKey: string, isSortedDescending?: boolean): T[] {
        const key = columnKey as keyof T;
        return items.slice(0).sort((a: T, b: T) => {
            const aDate = parseDate(a[key] as string);
            const bDate = parseDate(b[key] as string);
            if (!aDate || !bDate) return 0;
            return isSortedDescending ? aDate < bDate ? 1 : -1 : aDate > bDate ? 1 : -1;
        });
    }


    const options: IDropdownOption[] = [
        { key: 'internalCARefNo', text: 'CA internal Assessment No.' },
        { key: 'name', text: 'EU sectoral legislative basis' },
        { key: 'dateOfAssessment', text: 'Date of assessment' },
    ];

    // State hooks for pagination and column management
    const [state, setState] = React.useState<Ipagination>({
        // selectedTab: Tab.Active,
        // isMetricsCalloutVisible: false,
        columnsState: _AssessmentColumns,
        currentPage: 1,
        itemsPerPage: 10,
        totalItems: 0

    });

    //pagination
    const totalItemsToPass = totalItems !== undefined ? totalItems : 0;


    // Function to handle page change pagination
    function _onPageChange(selectedItem: number) {
        setState({
            ...state,
            currentPage: selectedItem
        });


    }

    // Effect to handle itemsPerPage change and update displayed items pagination
    useEffect(() => {

        const startIndex = (state.currentPage - 1) * state.itemsPerPage;
        const endIndex = Math.min(startIndex + state.itemsPerPage, itemsAssessment.length);
        const itemsOnCurrentPage = itemsOrg.slice(startIndex, endIndex);

        setItems(itemsOnCurrentPage);
    }, [state.currentPage, state.itemsPerPage, itemsAssessment]);



    // Function to handle itemsPerPage change pagination
    function _onChangeItemsPerPage(event: React.FormEvent<HTMLDivElement>, item: IDropdownOption) {
        setState({
            ...state,
            itemsPerPage: item.key as number,
            currentPage: 1
        });
    }


    let SelectDialog: any;
    switch (valueDropdown) {
        case "Add":
            SelectDialog = <AddEditDialog
                item={initialAssessment}
                items={items}
                setItems={setItems}
                dialogIsHidden={dialogIsHidden}
                setDialogIsHidden={setDialogIsHidden}
                title="Add assessment"
                POIId={itemPOI?.id}
                handleActionResponse={handleActionResponse}
                isAdd={true}
            />;
            break;
        default:
            SelectDialog = <AddEditDialog
                item={editItem}
                items={items}
                setItems={setItems}
                dialogIsHidden={dialogIsHidden}
                setDialogIsHidden={setDialogIsHidden}
                title="Edit assessment"
                dateOfAssessment={DOAssessment}
                POIId={itemPOI?.id}
                handleActionResponse={handleActionResponse}
            />;
            break;
    }

    const addTooltipToColumnHeader = (cols: IColumn[]) => {
        const a = cols.map((column) => ({
            ...column,
            onRenderHeader: () => (
                <TooltipHost overflowMode={TooltipOverflowMode.Parent} content={column.name}>{column.name}</TooltipHost>
            ),
        }))
        return cols;
    }

    function _renderItemColumn(item?: any, index?: number, column?: IColumn) {
        if (item && column) {
            const fieldContent = item[column.fieldName as keyof any] as string;
            return <TooltipHost overflowMode={TooltipOverflowMode.Parent} content={fieldContent}>{fieldContent}</TooltipHost>
        }
    }

    return (
        <div className="POI">
            <Stack>
                <PageTitle title="Assessments" name={itemPOI ? itemPOI.firstName ? itemPOI.firstName + " " + itemPOI.lastName : itemPOI.legalName : ""} />
            </Stack>
            <Stack horizontal className={styles.FilterByAssessment} styles={betweenStackStyles}>
                <QuickSearch options={options} items={items} itemsOrg={itemsOrg} onItemsProcessed={handleItemsProcessed} columns={_AssessmentColumns} textFieldStyles={customTextFieldStyles} dropdownStyles={customDropdownStyles} />
                <ActionButton iconProps={add} onClick={() => { setEditItem(orig); setValueDropdown("Add"); handleOpenDialog(); }} className={styles.FilterButton} >
                    Add Assessment
                </ActionButton>
            </Stack>
            <Stack styles={stackStylesSection}>
                <DetailsList layoutMode={1}
                    columns={addTooltipToColumnHeader(_AssessmentColumns)}
                    items={items}
                    onRenderItemColumn={_renderItemColumn}
                    selectionMode={SelectionMode.none}
                    selectionPreservedOnEmptyClick={true}
                />
            </Stack>
            {SelectDialog}
            <DeleteDialog
                id={editItem.id}
                encryptedId={editItem.encryptedId}
                dialogIsHiddenDelete={dialogIsHiddenDelete}
                setDialogIsHiddenDelete={setDialogIsHiddenDelete}
                title="Delete assessment"
                handleActionResponse={handleActionResponse}
            />

            <StackItem>
                <Pagination


                    currentPage={state.currentPage}
                    onPageChange={_onPageChange}
                    itemsPerPage={state.itemsPerPage}
                    onChangeItemsPerPage={_onChangeItemsPerPage}
                    totalItems={totalItemsToPass}

                />
            </StackItem>
        </div>

    );
}

export default AssessmentList;
